import "../style.css";
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "./utils/LanguageContext";


export default function PanelContent({ id, route, frTitle, enTitle, frSubtitle, enSubtitle, frText, enText, frRightButton, enRightButton, frLeftButton, enLeftButton, prev, next }) {
    const location = useLocation();
    const { language } = useLanguage();


    useEffect(() => {
        const panel = document.querySelector(`#${id}`);
        if (location.pathname === route) {
            setTimeout(() => {
                panel.style.transform = 'translate(0, 0%)';
            }, 3000);
        } else {
            panel.style.transform = 'translate(0, 150%)';
        }
    }, [location, route, id]);


    return (
        <div id={id} className="absolute bottom-0 md:bottom-10 md:left-10 w-full md:w-1/2 max-w-[550px] h-auto flex flex-wrap justify-between flex-col items-start p-6 md:p-10 bg-second shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] transform translate-y-[150%] transition-all ease-in-out duration-[1500ms] z-10">
            <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-1">
                    <h1 className="font-['md-avenir'] text-2xl md:text-3xl text-first">{language === "EN" ? enTitle : frTitle}</h1>
                    <h2 className="font-['sm-avenir'] text-xs md:text-sm text-first uppercase">{language === "EN" ? enSubtitle : frSubtitle}</h2>
                </div>   
                <p className="font-['sm-avenir'] text-sm md:text-base text-first leading-6 md:leading-7">{language === "EN" ? enText : frText}</p>
            </div>
            <div className="relative w-full flex justify-end items-strech gap-2 mt-4">
                {prev && (
                    <Link to={prev} className="flex items-center hover:bg-first_alt bg-first transition-all ease-in-out duration-300 uppercase font-['md-avenir'] text-sm md:text-base text-second no-underline px-5 md:px-6 py-3.5 md:py-4">
                    {(language === "EN" ? enRightButton : frRightButton) === "" ? 
                        <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            xmlns="http://www.w3.org/2000/svg"
                            className="fill-second text-base"
                        >
                            <path d="M8.68907 1.68568L4.56454 5.50492L8.68907 9.32416C9.10364 9.70805 9.10364 10.3282 8.68907 10.7121C8.27449 11.096 7.60478 11.096 7.19021 10.7121L2.31093 6.19396C1.89636 5.81007 1.89636 5.18993 2.31093 4.80604L7.19021 0.287919C7.60478 -0.0959731 8.27449 -0.0959731 8.68907 0.287919C9.09301 0.671812 9.10364 1.30179 8.68907 1.68568Z" />
                        </svg>
                    : 
                        (language === "EN" ? enLeftButton : frLeftButton) || 
                        <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            xmlns="http://www.w3.org/2000/svg"
                            className="fill-second text-base"
                        >
                            <path d="M8.68907 1.68568L4.56454 5.50492L8.68907 9.32416C9.10364 9.70805 9.10364 10.3282 8.68907 10.7121C8.27449 11.096 7.60478 11.096 7.19021 10.7121L2.31093 6.19396C1.89636 5.81007 1.89636 5.18993 2.31093 4.80604L7.19021 0.287919C7.60478 -0.0959731 8.27449 -0.0959731 8.68907 0.287919C9.09301 0.671812 9.10364 1.30179 8.68907 1.68568Z" />
                        </svg>
                    }
                    </Link>
                )}
                {next && (
                    <Link to={next} className="flex justify-end items-start bg-first hover:bg-first_alt transition-all ease-in-out duration-300 text-sm md:text-base uppercase font-['md-avenir'] text-sm md:text-base text-second no-underline px-5 md:px-6 py-3.5 md:py-4">
                        {language === "EN" ? enRightButton : frRightButton}
                    </Link>
                )}
            </div>
        </div>
    );
}
